import { createAction } from '@reduxjs/toolkit';

export const ACCEPT_SMS_ACTION_TYPE = 'saga/acceptSms';
export const acceptSmsAction = createAction(ACCEPT_SMS_ACTION_TYPE);
